const getClickableProps = (callback) => ({
  tabIndex: 0,
  role: "button",
  onMouseDown: callback,
  onKeyDown: (e) => e.key === "Enter" && callback(e),
})

export default getClickableProps;
